export const offersSelector = (state) => state.availableOffers.offers;
export const statusSelector = (state) => state.availableOffers.status;